module.exports = __webpack_public_path__ + "static/media/image9.a120e179.jpg";